(function (window) {
    window['env'] = window['env'] || {};
  })(this);
  